module.exports = __webpack_public_path__ + "static/media/aryan_mehta.07e83862.png";